export const CONTACT = {
  name: 'betaris Glanzwerk', owner: 'Baris Uysal',
  phone: '0162 2514810', phoneHref: 'tel:+491622514810',
  email: 'info@betaris-glanzwerk.de',
  address: 'Kastellstr. 37', city: '74080 Heilbronn',
};

export const SERVICE_GROUPS = [
  { id: 'reinigung', number: '01', title: 'Reinigungsleistungen', short: 'Reinigung',
    description: 'Mehr als sauber. Ein Ort, an dem man sich wohlfühlt. Zuhause und bei der Arbeit.',
    items: ['Wohnungsreinigung', 'Büro- & Praxisreinigung', 'Treppenhausreinigung', 'Kindergarten- & Schulreinigung', 'Grundreinigung', 'Bauendreinigung', 'Unterhaltsreinigung'] },
  { id: 'hausmeister', number: '02', title: 'Hausmeisterservice', short: 'Hausmeisterservice',
    description: 'Ein wachsames Auge. Eine helfende Hand. Für alles, was Ihr Objekt im Alltag braucht.',
    items: ['Mülltonnenservice', 'Glühbirnen wechseln', 'Kleine Reparaturen (ohne Handwerk)', 'Objektkontrollen', 'Außenanlagenpflege'] },
  { id: 'winterdienst', number: '03', title: 'Winterdienst', short: 'Winterdienst',
    description: 'Wenn der Winter kommt, sind wir an Ihrer Seite. Für freie Wege und ein gutes Gefühl.',
    items: ['Schneeräumen', 'Streuen von Gehwegen & Höfen'] },
];

export const NAV_LINKS = [
  { href: '#leistungen', label: 'Leistungen', id: 'services' },
  { href: '#ueber-uns', label: 'Über uns', id: 'about' },
  { href: '#einsatzgebiet', label: 'Einsatzgebiet', id: 'area' },
];